import React from 'react';
import './customText.scss';

interface CustomTextInterface {
  text: string;
}

export const CustomH2: React.FC<CustomTextInterface> = ({ text }) => (
  <h2 className="h2">{text}</h2>
);

export const CustomH3: React.FC<CustomTextInterface> = ({ text }) => (
  <h3 className="h3">{text}</h3>
);
